import React, { FC } from 'react';
import { ButtonGroup, Card, CardContent, CardHeader, ClickAwayListener, Grid, Grow, IconButton, MenuItem, MenuList, Paper, Popper } from '@material-ui/core';
import { MoreVert } from '@material-ui/icons';
import { Link } from 'react-router-dom';
import { useStyles } from './styles';
import { DocumentIcon, OverflowTip, PercentageIcon } from '../../../../components';
import { PATH_CASHBACK, PATH_IB_CLIENTS_CASHBACK } from '../../../../utils';

interface Props {
  translation: any;
  isActive: boolean;
}

export const Cashback: FC<Props> = ({ translation, isActive }) => {
  const classes = useStyles();
  const [open, setOpen] = React.useState(false);
  const anchorRef = React.useRef<HTMLDivElement>(null);

  const handleToggle = () => {
    setOpen((prevOpen) => !prevOpen);
  };

  const handleClose = (event: React.MouseEvent<Document, MouseEvent>) => {
    if (anchorRef.current && anchorRef.current.contains(event.target as HTMLElement)) {
      return;
    }

    setOpen(false);
  };

  return (
    <Card className={`${classes.root} ${classes.cashback}`}>
      <CardHeader
        disableTypography
        classes={{ content: classes.title }}
        action={
          <>
            <ButtonGroup ref={anchorRef} className={classes.buttonGroup}>
              <IconButton className={classes.button} onClick={handleToggle}>
                <MoreVert />
              </IconButton>
            </ButtonGroup>
            <Popper open={open} anchorEl={anchorRef.current} placement="left-start" transition disablePortal style={{ zIndex: 6000 }}>
              {({ TransitionProps }) => (
                <Grow {...TransitionProps}>
                  <Paper>
                    <ClickAwayListener onClickAway={handleClose}>
                      <MenuList className={classes.menuList}>
                        <MenuItem className={classes.menuItem} component={Link} to={PATH_CASHBACK}>
                          <PercentageIcon />
                          <span className={classes.menuItemText}>{translation.manage_campaigns}</span>
                        </MenuItem>
                        <span className={classes.menuTitle}>{translation.text_6663}</span>
                        <MenuItem className={classes.menuItem} component={Link} to={PATH_IB_CLIENTS_CASHBACK}>
                          <DocumentIcon />
                          <span className={classes.menuItemText}>{translation.ib_clients_cashback}</span>
                        </MenuItem>
                      </MenuList>
                    </ClickAwayListener>
                  </Paper>
                </Grow>
              )}
            </Popper>
          </>
        }
        title={<OverflowTip title={translation.cashbackForClients}>{translation.cashbackForClients}</OverflowTip>}
      />
      <CardContent>
        <Grid className={classes.bottomContent} style={{ marginTop: 27 }}>
          <div className={classes.bottomContentItem}>{isActive ? translation.text_274 : translation.notYetActivated}</div>
        </Grid>
      </CardContent>
    </Card>
  );
};
